import React from 'react';
interface PageHeaderProps {
  title: string;
  subtitle?: string;
  backgroundImage: string;
}
const PageHeader = ({
  title,
  subtitle,
  backgroundImage
}: PageHeaderProps) => {
  return <div className="relative w-full bg-cover bg-center h-[400px] flex items-center justify-center" style={{
    backgroundImage: `url('${backgroundImage}')`
  }} data-id="element-515">
      <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-516"></div>
      <div className="relative z-10 text-center text-white px-4" data-id="element-517">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4" data-id="element-518">
          {title}
        </h1>
        {subtitle && <p className="text-xl md:text-2xl max-w-3xl mx-auto" data-id="element-519">{subtitle}</p>}
      </div>
    </div>;
};
export default PageHeader;